import installer from './defaults'
export * from '@element-plus/components'
export * from '@element-plus/constants'
export * from '@element-plus/directives'
export * from '@element-plus/hooks'
export * from '@element-plus/utils'
export * as IconsVue from '@element-plus/components/icons-vue/index'
export * as Formily from '@element-plus/formily/index'

export const install = installer.install
export const version = installer.version
export default installer
